import React from 'react';

export default function Footer() {
  const openAccessibilityWidget = (e) => {
    e.preventDefault();
    // Safely query the WebAbility widget injected DOM element and trigger a click
    const widgetBtn = document.querySelector('.asw-menu-btn') || 
                      document.querySelector('.asw-widget') || 
                      document.querySelector('.asw-btn');
                      
    if (widgetBtn) {
      widgetBtn.click();
    } else {
      // Robust fallback if class naming changes over time
      const defaultBtns = document.querySelectorAll('div[class*="asw"], button[aria-label*="Accessibility" i], button[title*="Accessibility" i]');
      if (defaultBtns.length > 0) {
        defaultBtns[0].click();
      }
    }
  };

  const openCookieWidget = (e) => {
    e.preventDefault();
    
    // Attempt 1: Try to click the GetTerms widget button if it exists in the DOM
    const gtBtn = document.querySelector('.gt-cookie-widget-btn') || 
                  document.querySelector('.gtermscmp-widget-btn') ||
                  document.querySelector('button[class*="getterms"]');
                  
    if (gtBtn) {
      gtBtn.click();
    } else {
      // Attempt 2: Create a raw DOM element to trigger event delegation.
      // React's event system sometimes prevents third-party scripts from seeing the click.
      const tempBtn = document.createElement('button');
      tempBtn.setAttribute('data-gt-cookie-widget-show', 'true');
      tempBtn.style.display = 'none';
      document.body.appendChild(tempBtn);
      tempBtn.click();
      
      setTimeout(() => {
        if (document.body.contains(tempBtn)) {
          document.body.removeChild(tempBtn);
        }
      }, 100);
    }
  };

  return (
    <footer className="w-full bg-[#0D0D0D] border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          
          {/* Brand & Copyright - Left Section */}
          <div className="md:col-span-4 flex flex-col">
            <div className="text-white text-xl sm:text-2xl tracking-tight mb-4 select-none">
              <span className="font-normal">studio</span>
              <span className="font-bold">timer</span>
            </div>
            <p className="text-[#A1A1AA] text-[14px]">
              © 2026 Claxxiq LLC.
            </p>
          </div>

          {/* Link Columns - Right Section */}
          <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-8">
            
            {/* Column 1: Legal */}
            <div className="flex flex-col gap-4">
              <span className="text-[#A1A1AA] text-[11px] font-bold tracking-widest uppercase mb-1">
                Legal
              </span>
              <a 
                href="https://gettermscdn.com/view/K4uXe/privacy/en-us" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple w-fit"
              >
                Privacy Policy
              </a>
              <a 
                href="https://gettermscdn.com/view/K4uXe/terms-of-service/en-us" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple w-fit"
              >
                Terms of Service
              </a>
              <a 
                href="https://gettermscdn.com/view/K4uXe/acceptable-use/en-us" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple w-fit"
              >
                Acceptable Use Policy
              </a>
              <a 
                href="https://gettermscdn.com/view/K4uXe/cookies/en-us" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple w-fit"
              >
                Cookie Policy
              </a>
            </div>

            {/* Column 2: Compliance */}
            <div className="flex flex-col gap-4">
              <span className="text-[#A1A1AA] text-[11px] font-bold tracking-widest uppercase mb-1">
                Compliance
              </span>
              <button 
                onClick={openCookieWidget}
                data-gt-cookie-widget-show="true"
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple outline-none cursor-pointer text-left w-fit"
              >
                Manage Cookie Preferences
              </button>
              <button 
                onClick={openAccessibilityWidget}
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple outline-none cursor-pointer text-left w-fit"
              >
                Manage Accessibility
              </button>
            </div>

            {/* Column 3: Help */}
            <div className="flex flex-col gap-4">
              <span className="text-[#A1A1AA] text-[11px] font-bold tracking-widest uppercase mb-1">
                Help
              </span>
              <a 
                href="mailto:support@help.studiotimer.app" 
                className="text-[#D4D4D8] text-[14px] hover:text-[#FFFFFF] transition-colors duration-200 ease-apple w-fit"
              >
                Support
              </a>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}